import { getModel } from '../../model/registry'
import styled from "styled-components"

import TextWidget from "./widgets/TextWidget"
import InfoCardWidget from "./widgets/InfoCardWidget"
import ListWidget from "./widgets/ListWidget"
import ChartWidget from "./widgets/ChartWidget"
import SubListWidget from "./widgets/SubListWidget"
import TotalWidget from "./widgets/TotalWidget"
import TableWidget from "./widgets/TableWidget"
import AreaChartWidget from "./widgets/analytics/AreaChartWidget"
import VerticalBarWidget from "./widgets/analytics/VerticalBarWidget"
import StackedBarWidget from "./widgets/analytics/StackedBarWidget"
import WaterfallWidget from "./widgets/analytics/WaterfallWidget"
import HorizontalBarWidget from "./widgets/analytics/HorizontalBarWidget"
import DonutWidget from "./widgets/analytics/DonutWidget"
import GaugeWidget from "./widgets/analytics/GaugeWidget"
import DataTableWidget from "./widgets/analytics/DataTableWidget"
import ActivityFeedWidget from "./widgets/analytics/ActivityFeedWidget"
import KpiTilesWidget from "./widgets/analytics/KpiTilesWidget"

// The analytics widgets (widgets/analytics/README.md) share one set of props.
// A double area is the area widget given two series.
const analyticsWidgets = {
  AreaChartWidget,
  DoubleAreaChartWidget: AreaChartWidget,
  DonutWidget,
  GaugeWidget,
  StackedBarWidget,
  WaterfallWidget,
  HorizontalBarWidget,
  VerticalBarWidget,
  DataTableWidget,
  ActivityFeedWidget,
  KpiTilesWidget,
}

const WidgetWrapper = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

const WidgetSwitcher = ({ type }) => {

  const config = getModel('widgetData')[type]
  if (!config) return (
    <p>Widget Not Found!</p>
  )

  const Analytics = analyticsWidgets[config.widgetType]
  if (Analytics) return (
    <WidgetWrapper>
      <Analytics type={type} data={config.widgetData} labels={config.widgetLabels} />
    </WidgetWrapper>
  )

  return (
    <WidgetWrapper>
      {config.widgetType === 'TextWidget' ? <TextWidget data={config.widgetData} type={type} labels={config.widgetLabels} /> : <></>}
      {config.widgetType === 'ListWidget' ? <ListWidget data={config.widgetData} type={type} labels={config.widgetLabels} /> : <></>}
      {config.widgetType === 'BarChartWidget' ? <ChartWidget widgetData={config.widgetData} type={type} labels={config.widgetLabels} /> : <></>}
      {config.widgetType === 'SubListWidget' ? <SubListWidget data={config.widgetData} type={type} labels={config.widgetLabels} /> : <></>}
      {config.widgetType === 'TotalWidget' ? <TotalWidget data={config.widgetData} type={type} labels={config.widgetLabels} /> : <></>}
      {config.widgetType === 'TableWidget' ? <TableWidget data={config.widgetData} type={type} labels={config.widgetLabels} /> : <></>}
      {config.widgetType === 'InfoCardWidget' ? <InfoCardWidget data={config.widgetData} type={type} labels={config.widgetLabels} /> : <></>}
    </WidgetWrapper>
  )
}

export default WidgetSwitcher
